
const routes = [
  {
    path: '/',
    name: 'auth',
    meta: {
      roles: ['all'],
      acess: false
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '../domains/auth/container.vue')
  },
  {
    path: '/plans',
    meta: { roles: ['master'], acess: true },
    name: 'Planos',
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'Planos',
        component: () => import('../domains/data-student/container.vue'),
        meta: {
          roles: ['student'],
          acess: true
        }
      }
    ]
  },
  {
    path: '/dashboard-review',
    name: 'Redações',
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'Redações',
        component: () => import(/* webpackChunkName: "teacher" */ '../domains/essay-reviewer/container.vue'),
        meta: {
          roles: ['reviewer'],
          acess: false
        }
      }
    ],
    meta: {
      roles: ['reviewer'],
      acess: true
    }
  },
  {
    path: '/temas',
    name: 'Temas',
    meta: { roles: ['master'], acess: true },
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'Temas',
        component: () => import('../domains/theme/container.vue'),
        meta: {
          roles: ['master'],
          acess: true
        }
      }
    ]
  },
  {
    path: '/modulos',
    name: 'Dashboard',
    meta: { roles: ['master'], acess: true },
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('../domains/videos/module.vue'),
        meta: {
          roles: ['master'],
          acess: true
        }
      }
    ]
  },
  {
    path: '/videos/:id',
    name: 'Vídeos',
    meta: { roles: ['master'], acess: true },
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'Vídeos',
        component: () => import('../domains/videos/index.vue'),
        meta: {
          roles: ['master'],
          acess: true
        }
      }
    ]
  },
  {
    path: '/home',
    name: 'Home',
    meta: { roles: ['student'], acess: true },
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('../domains/dashboard/index.vue'),
        meta: {
          roles: ['student'],
          acess: true
        }
      }
    ]
  },
  {
    path: '/redacao',
    name: 'Redação',
    meta: { roles: ['master'], acess: true },
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'Redação',
        component: () => import('../domains/essay/index.vue'),
        meta: {
          roles: ['master'],
          acess: true
        }
      }
    ]
  },
  // {
  //   path: '/material',
  //   name: 'Material de Apoio',
  //   meta: { roles: ['student', 'reviewer'], acess: true },
  //   component: () => import('../layouts/Administrative-Area.vue'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'Material de Apoio',
  //       component: () => import('../domains/support-material/container.vue'),
  //       meta: {
  //         roles: ['student', 'reviewer'],
  //         acess: true
  //       }
  //     }
  //   ]
  // },
  {
    path: '/rascunhos',
    component: () => import('../layouts/Administrative-Area.vue'),
    name: 'rascunhos',
    children: [
      {
        path: '',
        name: 'rascunhos',
        component: () => import('../domains/essay-draft/container.vue'),
        meta: {
          roles: ['master'],
          acess: true
        }
      }
    ],
    meta: {
      roles: ['master'],
      acess: true
    }
  },
  {
    path: '/pendentes',
    name: 'pendentes',
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'pendentes',
        component: () => import('../domains/essay-outstanding/container.vue'),
        meta: {
          roles: ['master'],
          acess: true
        }
      }
    ],
    meta: {
      roles: ['master'],
      acess: true
    }
  },
  {
    path: '/corrigidas',
    name: 'corrigidas',
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        path: '',
        name: 'corrigidas',
        component: () => import('../domains/essay-corrected/container.vue'),
        meta: {
          roles: ['master'],
          acess: true
        }
      },
      {
        path: ':id',
        name: 'corrigidas',
        component: () => import('../domains/essay-corrected/components/essay.vue'),
        meta: {
          roles: ['master'],
          acess: true
        }
      }
    ],
    meta: {
      roles: ['master'],
      acess: true
    }
  },
  {
    path: '/redacao/:id',
    component: () => import('../layouts/Administrative-Area.vue'),
    name: 'redacao',
    children: [
      {
        path: '',
        name: 'redacao',
        component: () => import('../domains/essay-send/container.vue'),
        meta: {
          roles: ['student'],
          acess: false
        }
      }
    ],
    meta: {
      roles: ['student'],
      acess: false
    }
  },
  {
    path: '/correcao/:id',
    name: 'correcao',
    component: () => import('../layouts/Administrative-Area.vue'),
    children: [
      {
        name: 'correcao',
        path: '',
        component: () => import('../domains/reviewer/container.vue'),
        meta: {
          roles: ['reviewer'],
          acess: false
        }
      }
    ],
    meta: {
      roles: ['reviewer'],
      acess: false
    }
  },
  {
    path: '/verificacao/:token',
    name: 'verify-account',
    meta: {
      roles: ['all'],
      acess: false
    },
    component: () => import(/* webpackChunkName: "teacher" */ '../domains/auth-student/components/verify.vue')
  },
  {
    path: '/payment/:code',
    name: 'payment',
    meta: {
      roles: ['all'],
      acess: false
    },
    component: () => import(/* webpackChunkName: "teacher" */ '../domains/home/components/Payment.vue')
  }
]

export default routes
